import {
  faAndroid,
  faFacebookF,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const speakers = [
  {
    name: "Thomas Alexandro",
    position: "Android Developer",
    imgUrl: "/img/speaker1.svg",
    desc: "",
    profLogo: faAndroid,
  },
  {
    name: "Jenny Jenifer",
    position: "Sales Manager at Facebook",
    imgUrl: "/img/speaker2.svg",
    desc: "",
    profLogo: faFacebookF,
  },
  {
    name: "Thomas Alexandro",
    position: "Product Manager at Youtube",
    imgUrl: "/img/speaker1.svg",
    desc: "",
    profLogo: faYoutube,
  },
  {
    name: "Jenny Jenifer",
    position: "Android Developer",
    imgUrl: "/img/speaker2.svg",
    desc: "",
    profLogo: faAndroid,
  },
];
export default speakers;
